module.exports = __webpack_public_path__ + "img/word1.4447d75c.png";